import { useMemo, useCallback } from "react";
import {
  MutationsObject,
  QueriesObject,
} from "../context/ContractorCardContext";

export const useContractorCardError = (
  queries: QueriesObject,
  mutations: MutationsObject,
) => {
  const errorState = useMemo(() => {
    const error =
      queries.contractorCardQuery.error ||
      mutations.updateContractorCardMutation.error;
    const isQuery = !!queries.contractorCardQuery.error;
    return { error, isQuery };
  }, [
    queries.contractorCardQuery.error,
    mutations.updateContractorCardMutation.error,
  ]);

  const clearError = useCallback(
    () => mutations.updateContractorCardMutation.reset(),
    [mutations.updateContractorCardMutation],
  );

  return { errorState, clearError };
};
